import React, { useEffect, useState } from "react";
import authService from "../services/authService";
import { useNavigate } from "react-router-dom";
import { BarChart3 } from "lucide-react";
import { PersonAdd, Hdd } from "react-bootstrap-icons";
import NotificationPanel from "./NotificationPanel";
import api from "../api/api";
import { WALKTHROUGH_REFRESH_EVENT } from "../utils/walkthroughEvents";
const Greeting = ({ showNotifications = true }) => {
  const [greeting, setGreeting] = useState("Hello, there!");
  const [canManageTeam, setCanManageTeam] = useState(false);
  const navigate = useNavigate();
  const isAuthenticated = authService.isAuthenticated();
  const isStaff = authService.isStaff();
  const isTherapist = authService.isTherapist() && !authService.isManagementOnly();
  const isClinicAdmin = authService.isClinicAdmin();

  useEffect(() => {
    let active = true;
    let requestId = 0;
    const checkAccess = () => {
      const current = ++requestId;
      if (!isAuthenticated || !isClinicAdmin) { setCanManageTeam(false); return; }
      // Therapist admins should only see Team after finishing their test client.
      // Management-only admins are not subject to the therapist walkthrough.
      const requests = [api.get('/clinic-team/')];
      if (isTherapist) requests.push(api.get('/therapist-walkthrough/'));
      Promise.all(requests).then(([teamResponse, walkthroughResponse]) => {
        const hasTeamAccess = Boolean(teamResponse.data.clinics?.length);
        const hasFinishedWalkthrough = !isTherapist ||
          !walkthroughResponse.data.eligible ||
          Boolean(walkthroughResponse.data.completed);
        if (active && current === requestId) {
          setCanManageTeam(hasTeamAccess && hasFinishedWalkthrough);
        }
      }).catch(() => { if (active && current === requestId) setCanManageTeam(false); });
    };
    checkAccess();
    window.addEventListener('focus', checkAccess);
    window.addEventListener(WALKTHROUGH_REFRESH_EVENT, checkAccess);
    return () => { active = false; window.removeEventListener('focus', checkAccess); window.removeEventListener(WALKTHROUGH_REFRESH_EVENT, checkAccess); };
  }, [isAuthenticated, isClinicAdmin, isTherapist]);

  useEffect(() => {
    if (isAuthenticated) {
      const firstName = localStorage.getItem("first_name");
      setGreeting(`Hello, ${firstName}!`);
    }
  }, [isAuthenticated]);

  const handleNavigate = () => {
    navigate("/");
  };

  const handleMetricsClick = () => {
    navigate("/metrics"); // Adjust this path as needed
  };

  return (
    <div className="d-flex justify-content-between align-items-center mt-3 px-3">
      <div className="d-flex align-items-center gap-3">
        {isStaff && (
          <>
          <BarChart3
            className="cursor-pointer text-primary hover:text-primary-dark transition-colors"
            size={35}
            onClick={handleMetricsClick}
          />
          <PersonAdd
            className="cursor-pointer text-primary hover:text-primary-dark transition-colors"
            size={33}
            onClick={() => navigate('/manage')}
          />
          <Hdd
            className="cursor-pointer text-primary hover:text-primary-dark transition-colors"
            size={33}
            title="Configure Test Server"
            onClick={() => navigate('/configure-test-server')}
          />
          </>
        )}
        {isAuthenticated && isClinicAdmin && canManageTeam && <button type="button" className="btn btn-outline-primary btn-sm therapist-walkthrough-team" onClick={() => navigate("/team")}>Team</button>}
        <div className="text-center">{greeting}</div>
      </div>
      <div className="d-flex align-items-center gap-2">
        {showNotifications && isAuthenticated && isTherapist && (
          <span className="therapist-walkthrough-notifications"><NotificationPanel /></span>
        )}
        <img
          src="/images/plasticise-logo.png"
          alt="Logo"
          onClick={handleNavigate}
          className="img-fluid"
          style={{ width: "50px", height: "auto" }}
        />
      </div>
    </div>
  );
};

export default Greeting;
